import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import styles from "./HandOver.module.scss";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import DatePicker from "react-datepicker";
import CustomerReservationsClient from "../../../../shared/clients/CustomerReservationsClient";
import { HANDOVER_DIALOGUES, HANDOVER_STATUS } from "./Constants";
import UiDateUtils from "../../../../utils/UiDateUtils";
import {
  TRANSLATED_DAYS,
  TRANSLATED_MONTHS,
} from "../../../../common/Constants";

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledDialog = withStyles({
  paper: {
    maxWidth: 607,
    height: 653,
  },
})(Dialog);

class HandOverReleaseCommsCalenderDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      earliestAppointmentDate: this.formatTodayDate(),
    };
    this.days = TRANSLATED_DAYS.map((days) => this.props.t(days.label));
    this.months = TRANSLATED_MONTHS.map((months) => this.props.t(months.label));
    this.locale = {
      localize: {
        day: (n) => this.days[n],
        month: (n) => this.months[n],
      },
      formatLong: {},
    };
  }

  handleClose = () => {
    this.props.handleDialogChange(
      null,
      HANDOVER_DIALOGUES.RELEASE_COMMS_CALENDER,
      HANDOVER_DIALOGUES.RELEASE_COMMS
    );
  };

  handleBack = () => {
    this.props.handleDialogChange(
      HANDOVER_DIALOGUES.RELEASE_COMMS,
      HANDOVER_DIALOGUES.RELEASE_COMMS_CALENDER
    );
  };

  handleReleaseComms = () => {
    this.props.handleDialogChange(
      null,
      HANDOVER_DIALOGUES.RELEASE_COMMS_CALENDER
    );
    const handOverData = this.getHandOverData();

    this.props.hideOrShow(true);
    CustomerReservationsClient.updateHandOver(
      this.props.token,
      handOverData,
      this.props.customerReservation.id
    )
      .then(() => {
        this.props.refreshOrderDetails();
      })
      .catch(() => {
        this.props.showErrorPopup(
          this.props.t("Error.processingErrorTitle"),
          this.props.t("Error.processingErrorMessage")
        );
      })
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  getHandOverData() {
    return {
      appointmentStatus: HANDOVER_STATUS.INITIAL,
      preferredNotesToDealer: "",
      dealerUserId: this.props.user.userId,
      preferredinitialDate: this.formatDate(this.state.earliestAppointmentDate),
      paymentType: this.props.customerReservation.paymentType,
    };
  }
  formatDate = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return UiDateUtils.formatDateYYYYMMDD(year, month, day);
  };

  updateDate = (date) => {
    if (date !== null) {
      this.setState({ earliestAppointmentDate: date }); //Set newly selected date
    }
  };

  formatTodayDate = () => {
    if (this.props.todayDate) {
      const dateString = this.props.todayDate;
      const year = dateString.substring(0, 4);
      const month = dateString.substring(5, 7);
      const day = dateString.substring(8, 10);
      return new Date(year, month - 1, day);
    } else return null;
  };

  formatMinDate = () => {
    if (this.props.todayDate) {
      const todayDate = this.props.todayDate.split("-");
      return new Date(todayDate[0], todayDate[1] - 1, todayDate[2]);
    } else return null;
  };

  render() {
    return this.props.open ? (
      <StyledDialog open={this.props.open} onClose={this.handleClose}>
        <div className={styles.dialog}>
          <Grid
            container
            data-testid="handOverReleaseCommsCalenderDialog"
            className={styles.dialogContainer}
            justify="center"
          >
            <Grid item md={12} className={styles.cancel}>
              <div>
                <button
                  data-testid="handOverReleaseCommsCalenderCloseDialog"
                  onClick={this.handleClose}
                >
                  <StyledClear />
                </button>
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.dialogTitle}>
                {this.props.t("HandOverReleaseCommsCalenderDialog.title")}
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.body}>
                <div className={styles.text}>
                  {this.props.t("HandOverReleaseCommsCalenderDialog.bodyText")}
                </div>

                <div
                  className={`${styles.paddingTop} calendarDialogContainer dialogWrapper`}
                >
                  <DatePicker
                    open={true}
                    locale={this.locale}
                    id="handOverReleaseCommsCalender"
                    selected={this.state.earliestAppointmentDate}
                    inline
                    shouldCloseOnSelect={false}
                    minDate={this.formatMinDate()}
                    onChange={this.updateDate}
                  />
                </div>
              </div>
            </Grid>

            <Grid item md={9}>
              <div className={styles.dialogActions}>
                <Button
                  className={styles.cancel}
                  name="handOverReleaseCommsCalenderBack"
                  data-testid="handOverReleaseCommsCalenderBack"
                  onClick={this.handleBack}
                >
                  {this.props.t("HandOverReleaseCommsCalenderDialog.back")}
                </Button>
                <Button
                  className={styles.next}
                  name="handOverReleaseCommsCalenderNext"
                  data-testid="handOverReleaseCommsCalenderNext"
                  onClick={this.handleReleaseComms}
                >
                  {this.props.t("HandOverReleaseCommsCalenderDialog.next")}
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </StyledDialog>
    ) : (
      ""
    );
  }
}

export default withTranslation("emp")(HandOverReleaseCommsCalenderDialog);
